import styled from 'styled-components'

export const AboutPagePicture = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;

  .body-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100vh;
    @media (max-width: ${({ theme }) => `${theme.size.sm}px`}) {
      height: 68vh;
    }
    .picture {
      width: 50%;
      background: ${({ theme }) => theme.colors.cream[300]};
      display: flex;
      justify-content: space-evenly;
      padding: 20vh 0 6vh;
      @media (max-width: ${({ theme }) => `${theme.size.sm}px`}) {
        padding-top: 16vh;
      }
      .spacer {
        width: 10px;
      }
      .image {
        background: url('/images/ps-45.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50% 50%;
        width: 417px;
        @media (max-width: ${({ theme }) => `${theme.size.sm}px`}) {
          position: absolute;
          z-index: 10;
          left: calc(50% - 150px);
          width: 300px;
          height: 300px;
        }
      }
    }
    .data {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      h1.meet {
        color: ${({ theme }) => theme.colors.cream[300]};
        text-transform: uppercase;
        transform: scale(1, 1) translate(0px, 0px) rotate(-90deg);
        font-size: 30vh;
        margin-top: 20vh;
        font-weight: bold;
        letter-spacing: -5px;
        line-height: 0.9;
        @media (max-width: ${({ theme }) => `${theme.size.sm}px`}) {
          font-size: 20vh;
          margin-top: 120vh;
        }
      }
      .text {
        font-size: 60px;
        font-style: italic;
        font-family: ${({ theme }) => theme.fonts.montserrat};
        z-index: 3;
        width: 50%;
        text-align: center;
        align-items: center;
        position: absolute;
        @media (max-width: ${({ theme }) => `${theme.size.sm}px`}) {
          font-size: 40px;
          //margin-top: 88vh;
        }
      }
    }
  }

  .content-data {
    margin-top: 10vh;
    display: flex;
    justify-content: center;
    .content {
      width: 60%;
      h2 {
        color: ${({ theme }) => theme.colors.gray[800]};
        font-family: ${({ theme }) => theme.fonts.montserrat};
        letter-spacing: 0.05em;
        line-height: 1.2;
        font-weight: 700;
        text-align: center;
        font-size: 23px;
      }
    }
  }
`
